import React, { useState } from 'react';
import { Luggage, Plane, DollarSign, MapPin, Phone, Mail, CheckCircle2 } from 'lucide-react';
import { Card, CardContent, CardHeader, CardTitle } from '../components/ui/card';
import { Button } from '../components/ui/button';
import { Input } from '../components/ui/input';
import { useToast } from '../hooks/use-toast';
import { Helmet } from 'react-helmet-async';

const ExcessBaggageShippingPage = () => {
  const [formData, setFormData] = useState({ name: '', email: '', phone: '', bags: '' });
  const { toast } = useToast();
  const handleChange = (e) => setFormData({ ...formData, [e.target.name]: e.target.value });
  const handleSubmit = (e) => {
    e.preventDefault();
    toast({ title: "Quote Request Received!", description: "We'll contact you with excess baggage rates." });
    setFormData({ name: '', email: '', phone: '', bags: '' });
  };

  return (
    <>
      <Helmet>
        <title>Excess Baggage Shipping Canada to India | Cheaper Than Airlines – Shippzy</title>
        <meta name="description" content="Ship excess baggage from Canada to India. Avoid expensive airline fees. Door-to-door delivery, multiple bag discounts. Perfect for students and travelers." />
        <link rel="canonical" href="https://www.shippzy.ca/excess-baggage-shipping-canada-to-india" />
      </Helmet>
      <div className="min-h-screen bg-white">
        <section className="bg-gradient-to-br from-gray-900 via-gray-800 to-black text-white py-20">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="max-w-4xl">
              <h1 className="text-5xl md:text-6xl font-bold mb-6">Excess Baggage Shipping Canada to India</h1>
              <p className="text-xl text-gray-300 mb-8">Avoid expensive airline excess baggage fees. Ship your extra bags from Canada to India at affordable rates with Shippzy. Perfect for students, travelers, and relocations.</p>
              <Button className="bg-gradient-to-r from-red-600 to-yellow-500 hover:from-red-700 hover:to-yellow-600 text-white px-8 py-6 text-lg" onClick={() => document.getElementById('quote-form').scrollIntoView({ behavior: 'smooth' })}>Get Quote</Button>
            </div>
          </div>
        </section>
        <section id="quote-form" className="py-20 bg-gradient-to-r from-red-600 to-yellow-500">
          <div className="max-w-2xl mx-auto px-4 sm:px-6 lg:px-8">
            <Card className="shadow-2xl">
              <CardHeader><CardTitle className="text-2xl text-center">Get Free Excess Baggage Quote</CardTitle></CardHeader>
              <CardContent>
                <form onSubmit={handleSubmit} className="space-y-4">
                  <Input name="name" value={formData.name} onChange={handleChange} required placeholder="Your name" />
                  <Input type="email" name="email" value={formData.email} onChange={handleChange} required placeholder="your@email.com" />
                  <Input type="tel" name="phone" value={formData.phone} onChange={handleChange} required placeholder="+1 (123) 456-7890" />
                  <Input type="number" name="bags" value={formData.bags} onChange={handleChange} placeholder="Number of bags" />
                  <Button type="submit" className="w-full bg-gradient-to-r from-red-600 to-yellow-500 text-white h-12">Get Quote Now</Button>
                </form>
              </CardContent>
            </Card>
          </div>
        </section>
      </div>
    </>
  );
};

export default ExcessBaggageShippingPage;
